import { Box, HStack, Text } from '@chakra-ui/react';
import UtilPriceFormatter from 'components/utils/UtilPriceFormatter';
import { useTranslation } from 'react-i18next';

type CartDiscountSummaryProps = {
  couponDiscountTotal: number;
  billDiscountTotal: number;
};

/**
 * Renders the discount breakdown shown in the cart and checkout summary totals:
 * a separate "ส่วนลดคูปอง" (coupon) line and a "ส่วนลดท้ายบิล" (bill-end) line.
 * The upsell hint lives in CartBillDiscountPromo, below the summary.
 */
function CartDiscountSummary({
  couponDiscountTotal,
  billDiscountTotal,
}: CartDiscountSummaryProps) {
  const { t } = useTranslation('cart');

  return (
    <>
      {couponDiscountTotal > 0 && (
        <HStack justifyContent="space-between">
          <Box flex={1}>
            <Text>
              {t('cart.summary.discount.couponLabel', {
                // TH: ส่วนลดคูปอง
                // EN: Coupon Discount
              })}
            </Text>
          </Box>
          <Box flex="0 0 auto" textAlign="right">
            <Text>
              <UtilPriceFormatter
                price={couponDiscountTotal ?? 0}
              ></UtilPriceFormatter>
            </Text>
          </Box>
        </HStack>
      )}
      {billDiscountTotal > 0 && (
        <HStack justifyContent="space-between">
          <Box flex={1}>
            <Text>
              {t('cart.summary.discount.bill', {
                // TH: ส่วนลดท้ายบิล
                // EN: Bill Discount
              })}
            </Text>
          </Box>
          <Box flex="0 0 auto" textAlign="right">
            <Text>
              <UtilPriceFormatter
                price={billDiscountTotal ?? 0}
              ></UtilPriceFormatter>
            </Text>
          </Box>
        </HStack>
      )}
    </>
  );
}

export default CartDiscountSummary;
